import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import PdfIframeViewer from "common/pdf-iframe-viewer";
import CustomDatePicker from "common/CustomDatePicker";
import CustomMonthPicker from "common/CustomMonthPicker";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { getpaySlipdetails } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import PayslipList from "../SalaryReport/MyPayslip/PayslipList";
import "../SalaryReport/MyPayslip/Payslip.css";
import Swal from 'sweetalert2';

const PayrollMyPayslip = () => {
  const [fileUrl, setFileUrl] = useState("https://css4.pub/2015/icelandic/dictionary.pdf");
  const dispatch = useDispatch();
  const [accessRight, setAccessRight] = useState(null);
  const [authDetails, setAuthDetails] = useState(null);
  const [data, setdata1] = useState(null);

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
  }, [dispatch]);

  const {
    payslipdetails,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    payslipdetails: state.PayrollReportsReducer?.payslipdetails ?? [],
    loading: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.loading,
    error: state.AttendanceLeaveManagReducer?.error,
    success: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.success,
  }));

  const formik = useFormik({
    initialValues: {
      salaryMonth: "",
    },
    validationSchema: Yup.object({
      salaryMonth: Yup.string().nullable().typeError("Salary Month is required").required("Salary Month is required"),
    }),
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("unit_id", authDetails?.unit_id);
      formData.append("saldate", values.salaryMonth);
      formData.append("cat_id", 0);
      formData.append("dept_id", 0);
      formData.append("emp_id", authDetails?.empid || 0);
      dispatch(getpaySlipdetails(formData));
    },
  });

  const resetFormData = () => {
    dispatch({ type: "RESET_SAVE_STATUS" });
    formik.resetForm({ values: { salaryMonth: "", }, });
  };

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Payroll / Reports" breadcrumbItem="My Payslip" />
        <Card>
          <CardBody>
            <Form onSubmit={formik.handleSubmit}>
              <Row className="justify-content-between align-items-center">
                <Col md={4}>
                  <FormGroup>
                    <Label>Salary Month <span className="text-danger">*</span></Label>
                    <CustomMonthPicker
                      name="salaryMonth"
                      value={formik.values.salaryMonth}
                      onChange={(date) => { formik.setFieldValue("salaryMonth", date); }}
                      onBlur={formik.handleBlur}
                      className={`form-control ${formik.touched.salaryMonth && formik.errors.salaryMonth ? "is-invalid" : ""}`}
                    />
                    {formik.touched.salaryMonth && formik.errors.salaryMonth && (
                      <div className="text-danger">{formik.errors.salaryMonth}</div>
                    )}
                  </FormGroup>
                </Col>
                <Col md={2} className="text-end d-flex align-items-center justify-content-end gap-2 mt-3">
                  <Button type="submit" color="primary" className="px-3 d-flex align-items-center"><i className="fas fa-search me-2"></i> SEARCH </Button>
                  <Button color="danger" className="px-3 d-flex align-items-center no-print" onClick={() => window.print()}>  <i className="fas fa-print me-2"></i>  PRINT</Button>
                  <Button type="reset" className="btn button-cancel"
                    onClick={() => {
                      Swal.fire({
                        title: "Are you sure?", text: "Unsaved clear will be lost!", icon: "warning",
                        showCancelButton: true, confirmButtonText: "Yes, Clear", cancelButtonText: "No", confirmButtonColor: "#3085d6", cancelButtonColor: "#d33"
                      }).then((result) => {
                        if (result.isConfirmed) {
                          resetFormData();
                        }
                      });
                    }}
                  >
                    <i className="fas fa-sync me-1" /> CANCEL
                  </Button>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>

        {/* PDF Viewer Section */}
        <Card>
          <CardBody>
            <PayslipList employees={payslipdetails} />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default PayrollMyPayslip;
